import { Grid, Stack, Typography, Chip, Card, Divider, ChipProps } from "@mui/material";
import * as React from "react";

import CheckIcon from "@mui/icons-material/Check";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";

import AssetThumbnail, { AssetThumbnailProps } from "../../Misc/AssetThumbnail";
import { useTranslation } from "react-i18next";

export interface ProviderRequestCardProps {
  title: string;
  desc: string;
  startDate: string;
  endDate: string;
  status: "pending" | "manual-rejected" | "auto-rejected" | "accepted" | string;
  assetType: AssetThumbnailProps["type"];
  comments: number;
}

const ProviderRequestCard: React.FC<ProviderRequestCardProps> = ({
  title,
  desc,
  startDate,
  endDate,
  status,
  assetType,
  comments,
}) => {
  const { t } = useTranslation();
  let statusColor: ChipProps["color"];
  let statusText = "";
  let statusIcon;

  switch (status) {
    case "accepted":
      statusColor = "success";
      statusIcon = <CheckIcon fontSize="small" />;
      statusText = t("common:manualRejection");
      break;
    case "manual-rejected":
      statusColor = "error";
      statusIcon = <CloseOutlinedIcon fontSize="small" />;
      statusText = t("common:manualRejection");
      break;
    case "auto-rejected":
      statusColor = "error";
      statusIcon = <CloseOutlinedIcon fontSize="small" />;
      statusText = t("common:autoRejection");
      break;
    default:
      statusColor = "info";
      statusIcon = <PublishOutlinedIcon fontSize="small" />;
      statusText = t("common:pendingUpload");
      break;
  }

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" spacing={3}>
        <Stack>
          <Typography component="h4" fontWeight={500}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.tier">
            {desc}
          </Typography>
        </Stack>
        <AssetThumbnail type={assetType} sx={{ flexShrink: 0 }} />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mt={2}>
        <Chip variant="outlined" label={statusText} icon={statusIcon} color={statusColor} />
        <Chip color="info" label={comments} icon={<CommentOutlinedIcon />} />
      </Stack>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Typography variant="body2" fontWeight={500} color="text.tier">
            {t("common:startDate")}
          </Typography>
          <Typography>{startDate}</Typography>
        </Grid>
        <Grid item md={6}>
          <Typography variant="body2" fontWeight={500} color="text.tier">
            {t("common:endDateLowerCase")}
          </Typography>
          <Typography>{endDate}</Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ProviderRequestCard;
